"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Pie = function Pie(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "pie",
    viewBox: "0 0 12 12"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-464.000000, -332.000000)",
    fill: "#000000"
  }, react_1["default"].createElement("g", {
    transform: "translate(130.000000, 296.000000)"
  }, react_1["default"].createElement("g", {
    transform: "translate(301.000000, 0.000000)"
  }, react_1["default"].createElement("g", {
    transform: "translate(23.000000, 26.000000)"
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, react_1["default"].createElement("path", {
    d: "M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M13,7.5 L8.5,7.5 L8.5,3.025 C10.8757473,3.25157392 12.7601943,5.12555177 13,7.5 L13,7.5 Z M7.71,13 C5.08236494,12.8777904 2.99876943,10.7405316 2.94340327,8.11063888 C2.88803711,5.48074614 4.8798365,3.25768955 7.5,3.025 L7.5,7.525 C7.5,8.07728475 7.94771525,8.525 8.5,8.525 L13,8.525 C12.7235662,11.1947214 10.3886091,13.1699451 7.71,13 L7.71,13 Z"
  })))))))));
};

exports["default"] = Pie;